import * as types from "../../mutation-types";
import {removeItem, addOrUpdateItem} from "../../helpers";

export default {
    [types.ADD_OR_UPDATE_SUBSCRIBER]: (state, item) => addOrUpdateItem(state, item, ['reference_type', 'reference_id', 'user_id']),
    [types.REMOVE_SUBSCRIBER]: (state, item) => removeItem(state, item, ['reference_type', 'reference_id', 'user_id'])
}